import {createRoot} from 'react-dom/client';
import App from './App';
import {NaviContextProvider} from './context/NaviCtx';

const container = document.getElementById('rvg-app');

const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<NaviContextProvider><App /></NaviContextProvider>);